// namespace
export const GUARDIANS_NAMESPACE = 'guardians'

// getters
export const GUARDIANS_GETTER = 'guardians'

// mutations
export const GUARDIANS_MUTATION_ENTIRE_GUARDIANS = 'updateEntireGuardians'
export const GUARDIANS_MUTATION_DELETE_GUARDIAN = 'deleteGuardian'

// actions
export const GUARDIANS_ACTION_GET_GUARDIANS = 'fetchGuardians'
export const GUARDIANS_ACTION_DELETE_GUARDIAN = 'deleteGuardian'



// WEBPACK FOOTER //
// ./src/store/modules/guardians-types.js